import PatientCarePatientList from "../../components/screen/patientCare/patientCarePatient/PatientCarePatientList";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const PatientCarePatientDatabasePage = () => {
  return (
    <PageTemplate
      header="Patient Database"
      mainComponent={
        <ThemeProvider theme={theme}>
          <PatientCarePatientList />
        </ThemeProvider>
      }
      pageRole={20}
    />
  );
};

export default HOC(PatientCarePatientDatabasePage);
